import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  inputField: {
    maxWidth: '200px'
  },
  smField: {
    maxWidth: '120px'
  },
  toggler: {
    margin: '0 10px 0 20px'
  },
  utility: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: '48px',
    '& .MuiSvgIcon-root': {
      marginRight: '10px'
    }
  },
  utilityActions: {
    alignItems: 'center',
    display: 'flex',
    flexShrink: '0',
    justifyContent: 'center'
  }
}));
export default useStyles;